import { Link } from 'react-router-dom';

interface FeaturedVenue {
  _id: string;
  name: string;
  description: string | null;
  address: {
    city?: string;
    state?: string;
  };
  firstHeroImage?: { cloudinaryPublicId: string; cloudinaryUrl: string } | null;
}

interface FeaturedWineryCardProps {
  venue: FeaturedVenue;
  index: number;
}

export const FeaturedWineryCard = ({ venue, index }: FeaturedWineryCardProps) => {
  const isEven = index % 2 === 0;
  const heroUrl = venue.firstHeroImage?.cloudinaryUrl;

  return (
    <Link
      to={`/wineries/${venue._id}`}
      className="group block overflow-hidden rounded-lg bg-gray-100 border border-gray-200 shadow-sm hover:shadow-md transition-shadow"
    >
      <div className={`flex flex-col ${isEven ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
        {/* Image side */}
        <div className="w-full md:w-1/2 h-64 md:h-80 flex-shrink-0">
          {heroUrl ? (
            <img
              src={heroUrl}
              alt={venue.name}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
          ) : (
            <div className="w-full h-full bg-stone-200 flex items-center justify-center">
              <svg className="w-16 h-16 text-stone-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909M3.75 21h16.5A2.25 2.25 0 0022.5 18.75V5.25A2.25 2.25 0 0020.25 3H3.75A2.25 2.25 0 001.5 5.25v13.5A2.25 2.25 0 003.75 21z" />
              </svg>
            </div>
          )}
        </div>

        {/* Text side */}
        <div className="w-full md:w-1/2 p-6 md:p-10 flex flex-col justify-center">
          {(venue.address?.city || venue.address?.state) && (
            <p className="text-xs font-sans font-medium tracking-[0.25em] uppercase text-stone-500 mb-2">
              {[venue.address.city, venue.address.state].filter(Boolean).join(', ')}
            </p>
          )}
          <h3 className="font-serif text-2xl md:text-3xl text-stone-900 mb-3 group-hover:text-stone-700 transition-colors">
            {venue.name}
          </h3>
          {venue.description && venue.description !== 'No description available' && (
            <p className="text-stone-600 leading-relaxed line-clamp-3 mb-4">
              {venue.description}
            </p>
          )}

        </div>
      </div>
    </Link>
  );
};
